import React, { useEffect, useState } from 'react'
import Button from '@taglivros/oef_componentes/build/components/button'
import Modal from '@taglivros/oef_componentes/build/components/modal'
import { bool, func, object } from 'prop-types'
import CodigoPix from '../CodigoPix/CodigoPix'
import InlineLoader from '../../components/InlineLoader/InlineLoader'
import { objetoTemPropriedade } from '../../utils/helpers/helpers'
import { Descricao, LoaderPix, ModalConteudoWrapper, ModalWrapper, Titulo, WrapperButton } from './styles'

const ModalPix = ( { acaoPosGerarPix, dadosPix, setBaixouPix, showModal, toggleModal } ) => {
  const [ clicouModal, setClicouModal ] = useState( false )
  const [ codigoPix, setCodigoPix ] = useState()
  const [ urlQrCode, setUrlQrCode ] = useState()

  useEffect(
    () => {
      if ( dadosPix && objetoTemPropriedade(
        dadosPix,
        'url'
      ) && objetoTemPropriedade(
        dadosPix,
        'dados'
      ) ) {
        setUrlQrCode( dadosPix.url )
        setCodigoPix( dadosPix.dados )
      }
    },
    [ dadosPix ]
  )

  useEffect(
    () => {
      if ( clicouModal ) {
        acaoPosGerarPix()
      }
    },
    [ clicouModal ]
  )

  return (
    <ModalWrapper>
      <Modal
        altura="auto"
        largura="500px"
        onShowModal={ toggleModal }
        show={ showModal }
      >
        { codigoPix && urlQrCode ?
          <ModalConteudoWrapper
            clicouModal={ clicouModal }
          >
            {
              clicouModal ?
                <LoaderPix>
                  <InlineLoader />
                </LoaderPix> : null
            }

            <Titulo>
              Concluir pagamento no Pix
            </Titulo>

            <Descricao>
              Para concluir, copie o código e cole no site/app do seu internet banking.
            </Descricao>

            <Descricao>
              { 'O seu kit só será enviado ' }

              <span className="destque">
                após a confirmação pela instituição financeira.
              </span>
            </Descricao>

            <CodigoPix
              codigoPix={ codigoPix }
              urlQrCode={ urlQrCode }
            />

            <WrapperButton>
              <Button
                invertido
                onClick={ () => {
                  toggleModal()
                  setClicouModal( false )
                  setBaixouPix( true )
                  acaoPosGerarPix()
                } }
                tema={ Button.BOTAO_CURADORIA }
              >
                Fechar
              </Button>
            </WrapperButton>
          </ModalConteudoWrapper> : <InlineLoader isCenter />}
      </Modal>
    </ModalWrapper>
  )
}

ModalPix.defaultProps = {
  'dadosPix': null,
  'showModal': false
}

ModalPix.propTypes = {
  'acaoPosGerarPix': func.isRequired,
  'dadosPix': object,
  'setBaixouPix': func.isRequired,
  'showModal': bool,
  'toggleModal': func.isRequired
}

export default ModalPix
